import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Router from 'vue-router'
import store from './store'
import 'vue2-org-tree/dist/style.css'
import './plugins/element.js'
import './plugins/echarts.js'
import './assets/scss/global.scss'
import './assets/css/base.css'
import { message } from './views/message/message.js'
import VueClipboard from 'vue-clipboard2'
import axios, {
  post
} from './util/http'
// import './assets/js/front'
import {
  treeData
} from './util/tree'
import common from './util/common'
import filterRules from './util/filterRules'
import './assets/icon/iconfont.css'
import './assets/icon/iconfontex.css'
import Vue2 from 'vue2-org-tree'
import * as filters from './util/filterCommon'
import 'default-passive-events'
import MyPluing from '@/util/install'
import { getToken } from '@/util/auth'
import indexApi from '@/api/workbench'
import { isSuccess } from '@/util/tool'
// import publicMixin from './mixin/publicMixin'
Vue.prototype.bus = new Vue()
Vue.prototype.$message = message
// Vue.use(publicMixin)
Vue.use(VueClipboard)
Vue.use(Vue2)
Vue.directive('cust', function (el, binding, vnode) {
  el.style.cursor = 'pointer'
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) // 插入过滤器名和对应方法
})
Vue.use(MyPluing)
Vue.prototype.$post = post
Vue.prototype.$axios = axios
Vue.prototype.$ConTree = treeData
Vue.config.productionTip = false
Vue.use(common)
Vue.use(filterRules)
// vue-router 版本出错解决方法
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
// 路由守卫
const authControlRouter = (to, from, next) => {
  store.state.isFalse = false
  const token = getToken()
  const toPath = to.path
  const formPath = from.path
  let toFlag = false
  let fromFlag = false
  store.state.dataSubMenuEx && store.state.dataSubMenuEx.forEach(subItem => {
    toFlag = toFlag || subItem.children.find(item => item.powerUrl === toPath)
    fromFlag = fromFlag || subItem.children.find(item => item.powerUrl === formPath)
  })
  store.state.dataSubMeunCurActiveEx = ''
  if (toFlag) {
    // 进入一级目录
    store.state.dataSubMeunCurActiveEx = toPath
  } else if (fromFlag && !toFlag) {
    // 离开一级目录
    store.state.dataSubMeunCurActiveEx = formPath
    // 离开当前模块时跳转到另外一个模块
    switch (toPath) {
      // 客户详情
      case '/crm/customer/details':
        store.state.dataSubMeunCurActiveEx = '/crm/customer/myCustomer'
        break
      case '/product/productManage/productDetails':
        // 产品详情
        store.state.dataSubMeunCurActiveEx = '/product/productManage/productList'
        break
      case '/crm/supplier/supplierEdit':
        // 供应商详情
        store.state.dataSubMeunCurActiveEx = '/crm/supplier/supplierList'
        break
    }
  }
  if (to.path === '/login' || token) {
    if (!to.query.cache_key) {
      // 准备一个跳转的query对象
      const query = to.query
      query.cache_key = Math.random()
      next({
        path: to.path,
        query: query
      })
    } else {
      const query = to.query
      query.cache_key = Math.random()
      next()
    }
  } else {
    next('/login')
  }
}
Vue.directive('compatibleTableWidth', {
  bind: function (el, binding, vnode) {
    el.style.width = parseInt(window.document.body.clientWidth) - 274 + 'px'
    el.style.overflow = 'hidden'
    window.onresize = () => {
      el.style.width = parseInt(window.document.body.clientWidth) - 274 + 'px'
    }
  },
  inserted: function (el) {
    el.style.width = parseInt(window.document.body.clientWidth) - 274 + 'px'
  },
  update: function (el) {
    el.style.width = parseInt(window.document.body.clientWidth) - 274 + 'px'
  },
  componentUpdated: function (el) {
    el.style.width = parseInt(window.document.body.clientWidth) - 274 + 'px'
  },
  unbind: function () {
    window.onresize = null
  }
})
router.beforeEach((to, form, next) => {
  authControlRouter(to, form, next)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
